module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"OpeningHours":{"statusClosed":"Nyní máme zavřeno","statusOpen":"Nyní máme otevřeno","closed":"zavřeno"}},"en":{"OpeningHours":{"statusClosed":"We are currently closed","statusOpen":"We are currently open"}}}')
  delete Component.options._Ctor
}
